import React, { useEffect, useState } from "react";
import styles from "./SizePriceList.module.css";

const SizePriceList = ({ sizeData, id = 0,
  mpid=0 ,productName = "",setItems }) => {
  const [quantities, setQuantities] = useState([]);

  const handleSizePrice = (item) => {    
    // return item.ps_whlprice
    if(Number(item?.ch_price || 0).toFixed(2) > Number(0).toFixed(2)){
      return item.ch_price;
      }else{
        return item.ps_whlprice;
    }    
  };

  const handleSizeMRP = (item) => {    
    // return item.ps_whlprice
    if(Number(item?.ch_mrp || 0).toFixed(2) > Number(0).toFixed(2)){
      return item.ch_mrp;
      }else{
        return item.ps_price;
    }    
  };
  const handleQuantityChange = (item, value) => {
    const qty = parseInt(value || 0, 10);
  
    const newItem = {
      sid: item?.sid,
      quote_id: 0,
      item_main_id: mpid,
      item_sub_id: item?.subid,
      item_id: id,
      item_name: productName,
      item_hsn: "",
      item_size: item?.sizename,
      item_qty: qty,
      item_mrp: handleSizeMRP(item),
      item_rate: handleSizePrice(item),
      item_amount: qty * handleSizePrice(item),
    };
  
    setQuantities((prev) => {
      const exists = prev.find((i) => i.sid === item.sid);
      if (exists) {
        return prev.map((i) => (i.sid === item.sid ? newItem : i));
      } else {
        return [...prev, newItem];
      }
    });
  
    setItems((prev) => {
      const exists = prev.find((i) => i.sid === item.sid);
      if (exists) {
        return prev.map((i) => (i.sid === item.sid ? newItem : i));
      } else {
        return [...prev, newItem];
      }
    });
  };
  
  
 
  return (
    <div className={styles.sizePriceContainer}>
      <ul className={styles.sizePriceList}>
        {sizeData.map((item) => (
          <li key={item.id} className={styles.sizePriceItem}>
            <span className={styles.sizeName}>{item.sizename}</span>
            <span className={styles.price}>₹{handleSizePrice(item)}</span>
            <input
              type="number"
              className={`form-control ${styles.quantityInput}`}
              name={`qty${item.id}`}
              min="0"
              onChange={(e) => handleQuantityChange(item, e.target.value)}
              style={{ textAlign: "end" }}
            />
          </li>
        ))}
      </ul>
     
    </div>
  );
};

export default SizePriceList;
